'use strict'
module.exports = class {

	input(name, input) {

		let label = document.createElement('label')
		label.className = 'form-row'
		label.innerHTML = `
			<span class="label"><span class="text">` + name + `</span></span>
			<span class="fieldbox"></span>
			<span class="border"></span>
		`
		this.inputBehavior(input)
		label.querySelector('.fieldbox').appendChild(input)
		input.onblur()
		return label
	}

	inputBehavior(input) {

		input.classList.add('field')

		input.onfocus = () => {
			let parent = input.closest('.form-row')
			parent.classList.remove('style-empty')
			parent.classList.add('style-focused')
		}

		input.onblur = () => {
			let parent = input.closest('.form-row')
			parent.classList.remove('style-focused')
			if (input.value === '') {
				parent.classList.add('style-empty')
			}
		}

	}

	actions(buttons) {

		if (!Array.isArray(buttons)) { buttons = [buttons] }

		let div = document.createElement('div')
		div.className = 'form-actions'
		let p = document.createElement('p')
		div.appendChild(p)

		buttons.forEach((btn) => {
			p.appendChild(btn)
		})

		return div

	}

}



//////////////////
// WEBPACK FOOTER
// ./src/helpers/forms.js
// module id = 2
// module chunks = 0